import { ThemeProps, useThemeContext } from '@nrdy-marketing-engine/theming';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export interface ComponentGroupProps {
  className?: string;
  children: ReactNode;
  spaced?: boolean;
  theme?: ThemeProps;
}

/**
 * A wrapper component that provides padding and theming for components inside, typically used to
 * separate the main sections of a page.
 */
function ComponentGroup({ className, children, spaced = true }: ComponentGroupProps) {
  const themeContext = useThemeContext();
  const classes = twMerge(
    'transition-[padding-top]',
    spaced && 'py-8 md:py-12 xl:py-18',
    spaced && themeContext.theme.sameBackgroundAsPrevious && 'pt-0 md:pt-0 xl:pt-0',
    className
  );

  return <div className={classes}>{children}</div>;
}

export default ComponentGroup;
